'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _BrowserView = require('../components/Browser/BrowserView.jsx');

var _BrowserView2 = _interopRequireDefault(_BrowserView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.folders;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    addFile: function addFile(file) {
      dispatch((0, _actions.addFile)(file));
    },
    addFiles: function addFiles(files) {
      dispatch((0, _actions.addFiles)(files));
    }
  };
};

var Browser = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BrowserView2.default);

exports.default = Browser;


//////////////////
// WEBPACK FOOTER
// ./client/containers/browser.js
// module id = 72
// module chunks = 0